import React from "react";
import { TopBar } from "../components/topBar/TopBar";
import SideBar from "../components/sideBar/SideBar";
import { Outlet } from "react-router-dom";

export interface PageLayoutProps extends React.PropsWithChildren {
  sidebar?: React.ReactElement;
}

export function PageLayout(props: PageLayoutProps) {
  const [isMenuCollapsed, setMenuCollapsed] = React.useState(false);
  const [isMenuExpanded, setMenuExpanded] = React.useState(false);

  const onSideBarToggle = () => {
    setMenuCollapsed(!isMenuCollapsed);
  };

  const onTopBarToggle = () => {
    setMenuExpanded(!isMenuExpanded);
  };

  return (
    <div id="main-wrapper" className="position-fixed d-flex flex-column w-100 h-100">
      <div id="main-topbar" className="position-relative flex-shrink-1">
        <TopBar showToggle={true} onToggle={onTopBarToggle}></TopBar>
      </div>
      <div className="position-relative flex-grow-1">
        <div className="position-absolute d-flex flex-row w-100 h-100">
          <nav id="main-menu" className={`h-100 mh-100 ${isMenuCollapsed ? "collapsed" : ""}  ${isMenuExpanded ? "expanded" : ""}`}>
            <SideBar showToggle={true} onToggle={onSideBarToggle}>
              {props.sidebar}
            </SideBar>
          </nav>
          <main id="main-content" role="main" className="flex-grow-1 h-100 mh-100 overflow-auto">
            {props.children ?? <Outlet />}
          </main>
        </div>
      </div>
    </div>
  );
}

PageLayout.defaultProps = {
  footerless: false,
};

export default PageLayout;
